import * as actionTypes from './types';

const INITIAL_STATE = {
  dateRange: null, // Stores [startDate, endDate] as ISO strings or null
  activeTab: '1',
  assetsDistributionTab: 'os',
  assetsSelection: ['top5'] // 'top5' means Top 5 default; numeric IDs are specific selections
};

const filterReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SET_DATE_RANGE:
      return {
        ...state,
        dateRange: action.payload
      };
    case actionTypes.SET_DASHBOARD_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload
      };
    case actionTypes.SET_ASSETS_DISTRIBUTION_TAB:
      return {
        ...state,
        assetsDistributionTab: action.payload
      };
    case actionTypes.SET_ASSETS_SELECTION:
      return {
        ...state,
        assetsSelection: action.payload
      };
    case actionTypes.RESET_DATE_RANGE:
      return {
        ...state,
        dateRange: null
      };
    default:
      return state;
  }
};

export default filterReducer;
